import { UserModel } from 'app/core/mips/common/models/user.model';

export interface UserLoggedInState {
    loggedInUser: UserModel | null;
  }

export const initialLoggedInUserState: UserLoggedInState = {
    loggedInUser: null
};